export default __webpack_public_path__ + "static/we-get-down_hero-aa37eaa9ed5acafa82b3f98d5542b011.png";